<style>
    body {
        background: #f8f8f8;
        margin: 0;
        padding: 0;
    }

    p {
        margin: 0;
    }

    ul {
        margin: 0;
        padding: 0;
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    .header {
        padding: 40px;
    }

    .content {
        background: #fff;
    }

</style>

<template>
    <div id="component">
        <CRow>
            <CCol sm="8">
                <CCard>
                    <CCardHeader>
                        앨범 상세
                    </CCardHeader>
                    <CCardBody>
                        <CForm>
                            <!--<CInput prepend="환자번호" v-model="custId" disabled>
                                <template #append-content>
                                    <CIcon name="cil-user"/>
                                </template>
                            </CInput>-->
                            <CInput prepend="대상자이름" v-model="name" disabled>
                                <template #append-content>
                                    <CIcon name="cil-user"/>
                                </template>
                            </CInput>
                            <CInput prepend="진료번호" v-model="registNo" disabled>
                                <template #append-content>
                                    <CIcon name="cil-user"/>
                                </template>
                            </CInput>
                            <CInput prepend="사진번호" v-model="albumId" disabled>
                                <template #append-content>
                                    <CIcon name="cil-user"/>
                                </template>
                            </CInput>
                            <CInput type="date" v-model="picDate"  prepend="날짜" disabled>
                            </CInput>
                            <div class="card-body p-3 d-flex align-items-center">
                                <div class="bg-gradient-warning mfe-3">
                                </div>
                            </div>
                            <uploader
                                    v-model="fileList"
                                    url="silver/fileUpload"
                                    title="이미지 (클릭하면 전체화면으로 노출됩니다.)"
                                    name="upload"
                                    readonly
                                    limit="1"
                                    :params="{
                                      custId: '1',
                                      checkDate:this.$moment().format('YYYYMMDD'),
                                    }"
                                                                :headers="{
                                      'custom-header': 'custom-info',
                                    }"
                                    @on-change="onChange"
                                    @on-cancel="onCancel"
                                    @on-success="onSuccess"
                                    @on-error="onError"
                            />
                            <div class="form-group form-actions">
                                <div class="col-sm-0.5">
                                    <CButton label=""
                                             type="button"
                                             style="text-align: right"
                                             class="btn btn-info " @click="backHistory">뒤로가기
                                    </CButton>

                                    <CButton label=""
                                             type="button"
                                             style="text-align: center; float: right; margin-right:10px;"
                                             class="btn btn-info " @click="deleteAlbum">삭제
                                    </CButton>
                                </div>
                            </div>
                        </CForm>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Uploader from "vux-uploader-component";
    import vueFilePond from 'vue-filepond';
    import VueMoment from 'vue-moment'
    import Vue from 'vue'
    import axios from "axios";

    Vue.use(VueMoment)

    export default {
        name: 'app',
        components: {
            Uploader
        },
        data() {
            return {
                custId: this.$route.params.custId,
                picDate: this.$moment(this.$route.params.picDate).format('YYYY-MM-DD'),
                url: '',
                albumId: this.$route.params.albumId,
                adminId: '',
                name:"",
                registNo:"",
                fileList: [
                ]
            }
        },
        mounted() {
            axios.get("silver/cust/album/view",{
                params: { custId: this.$route.params.custId, picDate : this.$route.params.picDate ,albumId: this.$route.params.albumId},
                timeout: 10000 // 1초 이내에 응답이 없으면 에러 처리
            })
                .then(res => {
                    console.log(res.data.custAlbum);
                    this.albumId = res.data.custAlbum.albumId;
                    this.custId = res.data.custAlbum.custId;
                    this.picDate =this.$moment(res.data.custAlbum.picDate).format('YYYY-MM-DD');
                    this.name = res.data.cust.name;
                    this.registNo = res.data.cust.registNo;

                    if (res.data.custAlbum.albumId != null) {
                        this.fileList.push({url: '/silver/fileLoad?albumId=' + res.data.custAlbum.albumId})
                    }
                    console.log(this.fileList);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        methods: {
            onChange(fileItem, fileList) {
                console.log('on-change: ', fileItem, fileList)
            },
            onCancel() {
                console.log('on-cancel: Sucess')
            },
            onSuccess(res, fileItem) {
                console.log('on-success: ', res)
                fileItem.fileid = res.data
                this.attachId = res.attachId
                console.log(this.attachId);
            },
            onError(res) {
                console.log('on-error: ', res)
            },
          /*  onDelete(cb) {
                this.attachId = '';
                console.log('on-delete: ', JSON.parse(JSON.stringify(this.fileList)))
                cb && cb()
            },*/
         albumUpdate() {
                axios.post('silver/cust/wellness/insert', {
                    custId: this.$route.params.custId,
                    checkDate: this.$moment(this.checkDate).format('YYYYMMDD'),
                    item1: this.item1,
                    item2: this.item2,
                    attachId: this.attachId,
                    memo: this.memo,
                })
                    .then(res => {
                        this.$router.push({name: 'paymanageupdate', params: {custId: this.custId}});

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            onload(e, r) {
                console.log(r)
            },
            deleteAlbum() {

                    axios.post('silver/cust/album/delete', {
                        albumId: this.albumId,
                    })
                        .then(res => {
                          alert("삭제되었습니다.");
                            this.$router.push({name:"paymanageupdate",params: {custId: this.$route.params.custId}})
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
            },
            backHistory() {
                this.$router.go(-1)
            },
        }
    }
</script>


